// extracted by mini-css-extract-plugin
module.exports = {"ellipsis":"TemplatesPage__ellipsis__27LjH","flex-child-ellipsis":"TemplatesPage__flex-child-ellipsis__2wDva","multiplayer-cursor":"TemplatesPage__multiplayer-cursor__3XU5c"};